import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import {
    cloudProcessOne,
    cloudProcessTwo,
    cloudProcessThree,
    cloudProcessFour,
    cloudProcessFive,
    cloudProcessSix,
} from "../../../app-constants";


function Services() {
  return (
    <section className='cloud__process cloud__services p-100 tekrevol_gray_bg'>
        <Container>
            <Row className='justify-content-center'>
                
                <Col
                    xs={12}
                    md={10}
                    lg={10}
                    xl={10}
                    xxl={10}
                    className="">
                    <div className="example text-center" data-text="">
                        <h2>Redefine Organizational Operations and Experiences with TekRevol’s <span>Cloud Support</span> and Maintenance Services</h2>
                    </div>
                </Col>
            </Row>
            <Row className='justify-content-center'>
                <Col
                 xs={12}
                 md={6}
                 lg={6}
                 xl={4}
                 xxl={4}
                 className="mb-4"
                >
                    <div className="serv-item h-100">
                        <div className='serv-inner bg-white text-center'>
                            <h2 className='title'>Cloud Infrastructure Maintenance</h2>
                            <p>We provide full-cycle cloud infrastructure maintenance services and support to ensure your cloud runs efficiently. We strive to improve resource allocation and achieve faster deployment timelines. Our major KPIs in cloud infrastructure management include automated provisioning and scaling and we deliver comprehensive optimization reports at predefined timelines.</p>
                        </div>
                    </div>
                </Col>
                <Col
                 xs={12}
                 md={6}
                 lg={6}
                 xl={4}
                 xxl={4}
                 className="mb-4"
                >
                    <div className="serv-item h-100">
                        <div className='serv-inner bg-white text-center'>
                            <h2 className='title'>Monitoring and Issue Resolution</h2>
                            <p>We proactively identify and resolve cloud-related issues before they impact your business. The major focus of TekRevol’s cloud maintenance team is to minimize downtime, reduce your MTTR (Mean Time To Repair), and improve application performance. We achieve this through 24/7 cloud infrastructure monitoring, real-time alerts, and expert troubleshooting and resolution.</p>
                        </div>
                    </div>
                </Col>
                <Col
                 xs={12}
                 md={6}
                 lg={6}
                 xl={4}
                 xxl={4}
                 className="mb-4"
                >
                    <div className="serv-item h-100">
                        <div className='serv-inner bg-white text-center'>
                            <h2 className='title'>Cloud Security </h2>
                            <p>We support your cloud environment with robust security measures to mitigate risks and protect your data. TekRevol’s cloud security services are ideal for businesses currently prioritizing zero security breaches, identification and remedy of vulnerabilities on an ongoing basis, and maintaining a compliant security posture. We perform regular security assessments, vulnerability scanning and patching, and security policy implementation and monitoring to meet KPIs in the cloud security standards.</p>
                        </div>
                    </div>
                </Col>
                <Col
                 xs={12}
                 md={6}
                 lg={6}
                 xl={4}
                 xxl={4}
                 className="mb-xl-0 mb-4"
                >
                    <div className="serv-item h-100">
                        <div className='serv-inner bg-white text-center'>
                            <h2 className='title'>Patch Management and Updates </h2>
                            <p>In patch management, our maintenance and support teams ensure your organization’s cloud infrastructure is always up-to-date with the latest security patches and software updates. This way, we help our clients reduce security vulnerabilities, improve system performance, and optimize resource utilization. To keep your cloud environment functional, we perform automated patches and document regular system health reports. </p>
                        </div>
                    </div>
                </Col>
                <Col
                 xs={12}
                 md={6}
                 lg={6}
                 xl={4}
                 xxl={4}
                 className="mb-md-0 mb-4"
                >
                    <div className="serv-item h-100">
                        <div className='serv-inner bg-white text-center'>
                            <h2 className='title'>Disaster Recovery</h2>
                            <p>Disaster recovery is our backup management service for helping organizations with their business continuity plans. In our disaster recovery services, we prepare your cloud environment for unforeseen disruptions with a comprehensive roadmap. This is a proactive, preventive service during which we ensure to minimize data loss, achieve rapid recovery times, and guarantee minimal business disruption. We build and test the disaster recovery plans, implement data backups, replicate strategies and document procedures so you can bounce back faster!</p>
                        </div>
                    </div>
                </Col>
                <Col
                 xs={12}
                 md={6}
                 lg={6}
                 xl={4}
                 xxl={4}
                 className="mb-0"
                >
                    <div className="serv-item h-100">
                        <div className='serv-inner bg-white text-center'>
                            <h2 className='title'>Initial Configuration <br className='d-xl-block d-none' />Support</h2>
                            <p>Because we are a full-cycle cloud implementation partner and have dedicated, platform-specific professionals, we also help with initial cloud setups and migration and ongoing support and maintenance. We streamline cloud adoption with for efficient cloud deployment, effective resource allocation, and an optimal security posture. With configuring the cloud environment, we implement security baselines and provide ongoing support and advice to get you up and running in the cloud quickly and securely.</p>
                        </div>
                    </div>
                </Col>
            </Row>
        </Container>
    </section>
  )
}

export default Services